module.exports = __webpack_public_path__ + "static/flags/MH-78f94de58cabd161b8f47d7aa5a8b75c.gif";